import React from 'react';
import Main from '../../Components/About/Main/Main';

export default (): React.ReactElement => (
  <Main />
);
